import { render, staticRenderFns } from "./ShipbluSelect.vue?vue&type=template&id=5849a4cd&scoped=true"
import script from "./ShipbluSelect.vue?vue&type=script&lang=js"
export * from "./ShipbluSelect.vue?vue&type=script&lang=js"
import style0 from "./ShipbluSelect.vue?vue&type=style&index=0&id=5849a4cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5849a4cd",
  null
  
)

export default component.exports